import FieldSet from '../../FieldSet';
import terminology from 'javascripts/terminology';

import { ReleaseDate } from './ReleaseDate';
import { ExternalReleaseDate } from './ExternalReleaseDate';

export class ReleaseDateFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [ReleaseDate, ExternalReleaseDate];
  }

  get title() {
    return `${terminology('Release')} date`;
  }
}
